import { createFileRoute } from '@tanstack/react-router'

import { DeliverablesPage } from '@/components/deliverables/deliverables-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'

export const Route = createFileRoute('/_app/projects/$projectRef_/livrables')({
  component: DeliverablesRoutePage,
})

function DeliverablesRoutePage() {
  const { projectRef } = Route.useParams()
  useFollowProjectClient(projectRef)
  return <DeliverablesPage projectRef={projectRef} />
}
